import { render, staticRenderFns } from "./CommercialForSale.vue?vue&type=template&id=899736c2"
import script from "./CommercialForSale.vue?vue&type=script&lang=ts"
export * from "./CommercialForSale.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports